
import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail, PhoneCall } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-madts-gray py-12 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-display font-bold mb-4 bg-gradient-to-r from-madts-purple to-madts-pink bg-clip-text text-transparent">
              MAD-T's
            </h3>
            <p className="text-gray-600 mb-4">
              Custom T-shirt printing for parties & special events that brings creativity
              and fun to any occasion.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com" className="text-gray-500 hover:text-madts-purple transition-colors">
                <Instagram />
              </a>
              <a href="https://facebook.com" className="text-gray-500 hover:text-madts-purple transition-colors">
                <Facebook />
              </a>
              <a href="https://twitter.com" className="text-gray-500 hover:text-madts-purple transition-colors">
                <Twitter />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-display font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-600 hover:text-madts-purple transition-colors">Home</Link></li>
              <li><Link to="/book" className="text-gray-600 hover:text-madts-purple transition-colors">Book Event</Link></li>
              <li><Link to="/shop" className="text-gray-600 hover:text-madts-purple transition-colors">Shop</Link></li>
              <li><Link to="/custom" className="text-gray-600 hover:text-madts-purple transition-colors">Custom Designs</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-semibold mb-4">Information</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-600 hover:text-madts-purple transition-colors">About Us</Link></li>
              <li><Link to="/faq" className="text-gray-600 hover:text-madts-purple transition-colors">FAQ</Link></li>
              <li><Link to="/business" className="text-gray-600 hover:text-madts-purple transition-colors">Business Collabs</Link></li>
              <li><Link to="/privacy" className="text-gray-600 hover:text-madts-purple transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-madts-purple" />
                <span className="text-gray-600">info@mad-ts.com</span>
              </li>
              <li className="flex items-center gap-2">
                <PhoneCall className="h-4 w-4 text-madts-purple" />
                <span className="text-gray-600">(555) 123-4567</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-gray-500">
          <p>© {new Date().getFullYear()} MAD-T's. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
